import validUrl from 'valid-url';

const { VITE_API_URL, VITE_DEFAULT_IMAGE } = import.meta.env;

export function getImageUrl(imagePath: string) {
  if (!imagePath) {
    return `${VITE_API_URL}${VITE_DEFAULT_IMAGE}`;
  }
  return !imagePath || validUrl.isUri(imagePath)
    ? imagePath
    : `${VITE_API_URL}images/${imagePath}`;
}

// 优先使用本地缓存的陪玩形象照
export function getBiggiePhotoUrl(record: any) {
  if (record?.local_photo) {
    return getImageUrl(record.local_photo);
  }
  return getImageUrl(record?.photo);
}

export function getGoodsImageUrl(imagePath: string) {
  if (!imagePath) {
    return `${VITE_API_URL}${VITE_DEFAULT_IMAGE}`;
  }
  return !imagePath || validUrl.isUri(imagePath)
    ? imagePath
    : `${VITE_API_URL}goodsimages/${imagePath}`;
}

export function getUserShowName(user: any) {
  if (!user || !user.union_id) {
    return '';
  }
  return `${user.nickname || ''}-${user.discriminator || ''}(${user.union_id})`;
}

export function getUserShowName2(
  unionId: any,
  nickname: any,
  discriminator: any
) {
  if (!unionId) {
    return '';
  }
  return `${nickname || ''}-${discriminator || ''}(${unionId})`;
}

export function getSummonerShowName(name: any, tag_line: any) {
  if (!name) {
    return '';
  }
  return `${name || ''}#${tag_line || ''}`;
}

export function x() {
  return 'test';
}

export function formatDateToLocal(dateStr) {
  if (!dateStr) return '';
  const date = new Date(dateStr);
  const yyyy = date.getFullYear();
  const MM = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
  const dd = String(date.getDate()).padStart(2, '0');
  const HH = String(date.getHours()).padStart(2, '0');
  const mm = String(date.getMinutes()).padStart(2, '0');
  const ss = String(date.getSeconds()).padStart(2, '0');

  return `${yyyy}-${MM}-${dd} ${HH}:${mm}:${ss}`;
}

export function formatDateToET(dateStr) {
  if (!dateStr) return '';
  const date = new Date(dateStr);
  return date.toLocaleString('en-US', {
    timeZone: 'America/New_York',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false,
  });
}
